import { FEATURES } from "@/content";
import { Reveal } from "@/components/landing/Reveal";

export const Features = () => (
  <section id="trust" data-testid="features-section" className="relative scroll-mt-28 border-t border-white/10 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-zinc-400">Why members stay</p>
        <h2 className="mt-4 max-w-3xl font-display text-2xl font-bold uppercase tracking-tight sm:text-4xl lg:text-5xl">
          Built on <span className="text-zinc-500">trust.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
        {FEATURES.map((feature, i) => {
          const Icon = feature.icon;
          return (
            <Reveal key={feature.id} delay={i * 0.1}>
              <article
                data-testid={`feature-card-${feature.id}`}
                className="group flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.02] p-8 transition-[border-color,background-color] duration-500 hover:border-white/30 hover:bg-white/[0.04]"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/15 bg-white/5">
                  <Icon className="h-5 w-5 text-zinc-300 transition-colors duration-500 group-hover:text-white" />
                </div>
                <h3 className="mt-8 font-display text-lg font-bold tracking-tight sm:text-xl">
                  {feature.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-zinc-400">{feature.description}</p>
                {feature.pills && (
                  <div className="mt-6 flex flex-wrap gap-2" data-testid="payment-pills">
                    {feature.pills.map((pill) => (
                      <span
                        key={pill}
                        className="rounded-full border border-white/10 px-3 py-1 text-xs text-zinc-400"
                      >
                        {pill}
                      </span>
                    ))}
                  </div>
                )}
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
